import { Injectable } from '@angular/core';
import { Model } from '@web-portal/domains/shared/domain-models';

@Injectable()
export abstract class ModelMapperStrategy<Payload = unknown, M = Model> {
  abstract mapToModel(modelData: Payload, apiConfig?: unknown): M;
}
